import React from 'react';

const Ellipsis: React.FC<React.PropsWithChildren<unknown>> = () => <span>...</span>;

export default Ellipsis;
